import { useState } from 'react';
import { Button, Stack, TextField, Typography } from '@mui/material';
import { Link } from '../../components/global/Link';
import { useAuth } from '../../contexts/AuthContext';
import AssetRegisterLogo from '../../assets/images/logo.svg';

interface SigninError {
  email?: string;
  password?: string;
  main?: string;
}

export const Signin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { signIn } = useAuth();
  const [error, setError] = useState<SigninError>({});

  const handleSignin = async () => {
    const { errors } = await signIn(email, password);

    if (errors) {
      if (errors.auth) {
        setError({
          main: 'Username or Password incorrect, Please try again',
        });
      } else {
        setError(errors);
      }
    } else {
      setError({});
    }
  };

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      height="100vh"
      paddingBottom={4}>
      <Stack sx={{ maxWidth: '500px', width: '100%' }} spacing={4}>
        <Stack width="100%" justifyContent="center" alignItems="center">
          <img src={AssetRegisterLogo} height={120} />
        </Stack>
        <Stack width="100%" justifyContent="center" alignItems="center" pt={8}>
          <Typography
            variant="h4"
            gutterBottom
            fontFamily="korolev-condensed"
            fontWeight="600"
            letterSpacing="1px">
            Sign In
          </Typography>
          <Typography
            variant="body2"
            gutterBottom
            fontStyle="italic"
            color="#DA0101">
            {error.main}
          </Typography>
        </Stack>
        <Stack component="form" width="100%" spacing={4}>
          <Stack width="100%">
            <Typography>Email</Typography>
            <TextField
              variant="outlined"
              value={email}
              error={error.email ? true : false}
              helperText={error?.email?.[0] ?? ''}
              onChange={e => setEmail(e.target.value)}
            />
          </Stack>
          <Stack width="100%">
            <Typography>Password</Typography>
            <TextField
              type="password"
              variant="outlined"
              value={password}
              error={error.password ? true : false}
              helperText={error?.password?.[0] ?? ''}
              onChange={e => setPassword(e.target.value)}
            />
          </Stack>
        </Stack>
        <Stack>
          <Link to="/password/forgot">
            <Typography variant="body2">Forgot Password?</Typography>
          </Link>
        </Stack>
        <Stack alignItems="center" justifyContent="center" pt={2}>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            sx={{ fontWeight: '900', textTransform: 'unset' }}
            onClick={handleSignin}>
            Sign In
          </Button>
        </Stack>
        <Stack alignItems="center" justifyContent="center" pt={2}>
          <Typography textAlign="center">
            By clicking ‘Sign In’, you are agreeing to the <br />
            <Link to="#">
              <span>terms of service</span>
            </Link>
            of Voittaa Ltd.
          </Typography>
          <Typography textAlign="center" pt={1}>
            Don't have an account?
            <Link to="/signup">
              <span>Signup here</span>
            </Link>
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
};
